<template>
	<div :class="getChartClass" v-scroll="handleScroll">
		<img :src="getChartUrl" :alt="getChartAlt">
	</div>
</template>

<script>

	export default {

		data: function() {
			return {
				scrolled: false,
			}
		},

		props: {
			name: {
				type: String,
				default: 'chart',
			},

			fx: {
				type: Boolean,
				default: false,
			}

		},

		computed: {

			getChartUrl: function() {

				return '/img/charts/' + this.name + '-' + window.appLang + '.svg'

			},

			getChartClass: function() {

				var c = "chart";

				if ( this.fx ) {

					c += ' fx';

				}

				if ( this.$data.scrolled ) {

					c += ' fx--on';

				}

				return c

			},

			getChartAlt: function() {

				return this._translate('ui.charts.' + this.name);

			}

		},

		methods: {

	  	handleScroll: function(e, el) {

	  		if ( ! this.fx ) { return false; }
	  		
	    	var bounding = el.getBoundingClientRect();
				if ( (window.innerHeight - bounding.top) >= (window.innerHeight/3) ) {
					this.$data.scrolled = true;
				};

	  	}

		}

	}
</script>

<style lang="scss">

	.chart {
		margin-top: 2rem;
	}

</style>